import { render, staticRenderFns } from "./CobroOnline.vue?vue&type=template&id=4367afcd"
import script from "./CobroOnline.vue?vue&type=script&lang=js"
export * from "./CobroOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports